module.exports = __webpack_public_path__ + "img/shield-slash.0a6db6e6.svg";